import React, { Component } from 'react';
import { Example, Properties, SourceCode } from 'examples';
import Button from '../Button/Button';
import PopupMenu from '../PopupMenu/PopupMenu';

export default class PopupMenuExample extends Component {

  state = {};

  onOpenMenu = e => {
    this.setState({
      anchor: e.target,
    }, () => {
      this.forceUpdate(); // force source code to update itself when opening menu
    });
  };

  onCloseMenu = e => {
    this.setState({
      anchor: null,
      customContent: false,
    });
  };

  onCustomPosition = e => {
    this.setState({
      anchor: { top: e.clientY, left: e.clientX }
    }, () => {
      this.forceUpdate(); // force source code to update itself when opening menu
    });
  };

  onOpenCustomMenu = e => {
    this.setState({
      anchor: e.target,
      customContent: true,
    }, () => {
      this.forceUpdate(); // force source code to update itself when opening menu
    });
  };

  onChange = e => this.setState(e.target.value);

  onClick = e => window.showAppInfo(e.target.innerHTML);

  onSubmit = e => {
    this.setState({ name: this.refName.value });
    this.onCloseMenu(e);
  };

  render() {
    const { anchor, customContent, position, name } = this.state;
    let popup;

    if (anchor || position) {
      let items;

      if (customContent) {
        items = (
          <div className="custom-menu" data-preventmenuclose>
            <p>What is your name?</p>
            <input ref={c => { this.refName = c; }}/>
            <Button className="primary" onClick={this.onSubmit}>Submit</Button>
          </div>
        );
      } else {
        items = [];
        items.push(<Button key="1" iconName="add" onClick={this.onClick}>Add</Button>);
        items.push(<Button key="2" iconName="delete" onClick={this.onClick}>Delete</Button>);
        items.push(<Button key="3" iconName="link" onClick={this.onClick}>Link</Button>);
        items.push(<Button key="4" disabled iconName="archive" onClick={this.onClick}>Archive</Button>);
      }
      popup = (
        <PopupMenu onClose={this.onCloseMenu} {...this.state} anchor={anchor} customContent={customContent}>
          {items}
        </PopupMenu>
      );
    }
    return (
      <Example {...this.props}>
        <Properties defaultProps={PopupMenu.defaultProps} propTypes={PopupMenu.propTypes} propValues={this.state}
          exclude={['anchor', 'customContent']} onChange={this.onChange}/>
        <div className="triggers">
          <Button onClick={this.onOpenMenu}>Button</Button>
          <Button onClick={this.onOpenMenu} iconName="action-menu" className="core-icon-button primary"/>
          <input onFocus={this.onOpenCustomMenu} value={name} placeholder="Show custom menu on onFocus"/>
        </div>
        <div className="custom-position" onClick={this.onCustomPosition}>
          <div>Click anywhere inside this area<br/>to open menu at mouse pointer.</div>
        </div>
        <SourceCode querySelector=".popup-menu-example .core-popup-menu" title="Generated HTML (expand and toggle menu)"/>
        {popup}
      </Example>
    );
  }

}
